import { System } from './System'

export class InventorySystem extends System {
  constructor(client) {
    super(client)
    this.items = []
  }

  setup(items) {
    this.items = items
  }
}
